export const PoiTableHeader = ({fetchedByGroupId, userIsAdmin}) => {
    return(
        <thead className="bg-gray-50 sticky-header">
        <tr>
          <th className="px-4 py-2 sticky-left sticky-left-header min-w-40">{fetchedByGroupId ? 'My POI Name' : 'Name'}</th>

          {fetchedByGroupId && 
            <th className="px-4 py-2">Original Name</th>
          }

          <th className="px-4 py-2">Site Type</th>
          <th className="px-4 py-2 min-w-40">{fetchedByGroupId ? 'Alt Description' : 'Description'}</th>
          <th className="px-4 py-2">My Groups</th>

          <th className="px-4 py-2 min-w-40">Lat</th>
          <th className="px-4 py-2 min-w-40 ">Lng</th>

          <th className="px-4 py-2 min-w-40">Intersect Lat</th>
          <th className="px-4 py-2 min-w-40">Intersect Lng</th>

          <th className="px-4 py-2 min-w-40">US Site</th>
          <th className="px-4 py-2 min-w-40">Dist To US (m)</th>

          <th className="px-4 py-2 min-w-40">DS Site</th>
          <th className="px-4 py-2 min-w-40">Dist To DS (m)</th>

          {/* actions */}
          {userIsAdmin && <th className="px-4 py-2">Add POI Below</th> }

          <th className="px-4 py-2">View on Map</th>

          {userIsAdmin && <th className="px-4 py-2">Delete POI</th> }
        </tr>
      </thead>
    )
}